export default __webpack_public_path__ + "static/media/chainCircle.f6e5a2c5.svg";